import { CoreModule } from '@abp/ng.core';
import { DataStore } from './../utility/data-store';
import { Component } from '@angular/core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';

@Component({
  selector: 'app-root',
  template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-dynamic-layout></abp-dynamic-layout>
  `,
  standalone: true,
  providers: [DataStore],
  imports: [
    CoreModule,
    ThemeSharedModule]
})
export class AppComponent {

  constructor(private dataStore: DataStore) {
    this.dataStore.ngOnInit();
  }
}
